const COLOR_BLACK_005 = '#f3f3f3' as const;
const COLOR_BLACK_015 = '#dbdbdb' as const;
const COLOR_BLACK_030 = '#b7b7b7' as const;
const COLOR_BLACK_050 = '#757575' as const;
const COLOR_BLACK_075 = '#4a4a4a' as const;
const COLOR_BLACK_100 = '#0e0e0e' as const;
const COLOR_BLUE_PERI_100 = '#d5e3fe' as const;
const COLOR_COVE_005 = '#f7fafc' as const;
const COLOR_COVE_100 = '#55a1bf' as const;
const COLOR_DEEP_SEA_005 = '#f3f9f7' as const;
const COLOR_DEEP_SEA_100 = '#15845D' as const;
const COLOR_NEON_LIME_100 = '#dcff51' as const;
const COLOR_NEON_LIME_105 = '#caf53d' as const;
const COLOR_ORANGE_PEEL_005 = '#fffaf2' as const;
const COLOR_ORANGE_PEEL_100 = '#ff9a00' as const;
const COLOR_PD_ULTRAMARINE_010 = '#eceffc' as const;
const COLOR_PD_ULTRAMARINE_085 = '#6477eb' as const;
const COLOR_PD_ULTRAMARINE_100 = '#495fe8' as const;
const COLOR_ROSE_005 = '#fcf5f7' as const;
const COLOR_ROSE_030 = '#eec1ce' as const;
const COLOR_ROSE_085 = '#cf4f74' as const;
const COLOR_ROSE_100 = '#c7305b' as const;
const COLOR_TAN_CLOUD_100 = '#fff5f1' as const; // tan-002
const COLOR_TAN_100 = '#0e0e0e';
const COLOR_TAN_090 = '#262525';
const COLOR_TAN_080 = '#3E3C3B';
const COLOR_TAN_075 = '#4A4847';
const COLOR_TAN_050 = '#868180';
const COLOR_TAN_030 = '#B7B0AD';
const COLOR_TAN_015 = '#DBD2CF';
const COLOR_TAN_010 = '#E7DEDA';
const COLOR_TAN_005 = '#F3E9E6';
const COLOR_TAN_002 = '#fff5f1'; // TAN_CLOUD_100
const COLOR_TEAL_SAGE_100 = '#90c7c1' as const;
const COLOR_WHITE_100 = '#ffffff' as const;

// All approved colors for general usage
// Excludes some semantic only colors so they are used properly
const COLORS = {
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
  BLACK_100: COLOR_BLACK_100,
  BLUE_PERI_100: COLOR_BLUE_PERI_100,
  NEON_LIME_100: COLOR_NEON_LIME_100,
  NEON_LIME_105: COLOR_NEON_LIME_105,
  PD_ULTRAMARINE_010: COLOR_PD_ULTRAMARINE_010,
  PD_ULTRAMARINE_085: COLOR_PD_ULTRAMARINE_085,
  PD_ULTRAMARINE_100: COLOR_PD_ULTRAMARINE_100,
  TAN_CLOUD_100: COLOR_TAN_CLOUD_100,
  TAN_100: COLOR_TAN_100,
  TAN_090: COLOR_TAN_090,
  TAN_080: COLOR_TAN_080,
  TAN_075: COLOR_TAN_075,
  TAN_050: COLOR_TAN_050,
  TAN_030: COLOR_TAN_030,
  TAN_015: COLOR_TAN_015,
  TAN_010: COLOR_TAN_010,
  TAN_005: COLOR_TAN_005,
  TAN_002: COLOR_TAN_002,
  TEAL_SAGE_100: COLOR_TEAL_SAGE_100,
  WHITE_100: COLOR_WHITE_100,
} as const;

// Brand Colors
export const COLORS_BRAND = {
  BLUE_PERI_100: COLOR_BLUE_PERI_100,
  NEON_LIME_100: COLOR_NEON_LIME_100,
  PD_ULTRAMARINE_100: COLOR_PD_ULTRAMARINE_100,
  TAN_CLOUD_100: COLOR_TAN_CLOUD_100,
  TEAL_SAGE_100: COLOR_TEAL_SAGE_100,
} as const;

// Gray Colors
export const COLORS_GRAYS = {
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
} as const;

// Semantic Colors
export const COLORS_SEMANTIC = {
  NEGATIVE_005: COLOR_ROSE_005,
  NEGATIVE_030: COLOR_ROSE_030,
  NEGATIVE_075: COLOR_ROSE_085,
  NEGATIVE_100: COLOR_ROSE_100,
  INFORMATIONAL_005: COLOR_COVE_005,
  INFORMATIONAL_100: COLOR_COVE_100,
  POSITIVE_005: COLOR_DEEP_SEA_005,
  POSITIVE_100: COLOR_DEEP_SEA_100,
  WARNING_005: COLOR_ORANGE_PEEL_005,
  WARNING_100: COLOR_ORANGE_PEEL_100,
} as const;

export default COLORS;
